import { styled } from '@mui/material/styles';

const CardGrid = styled('div')(({ theme: _theme }) => ({
  backgroundColor: 'transparent',
  margin: '20px 45px',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '0 2.00em',
}));

export default CardGrid;
